import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export const TestimonialCardVariant = {
  TESTIMONIAL: 'testimonial',
  QUOTE: 'quote',
  ICON: 'icon',
} as const;

export type TestimonialCardVariant =
  (typeof TestimonialCardVariant)[keyof typeof TestimonialCardVariant];

@Component({
  selector: 'om-testimonial-card',
  imports: [CommonModule],
  templateUrl: './testimonial-card.html',
  styleUrl: './testimonial-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestimonialCard {
  /** Layout variant: testimonial (with author), quote (quote + subtitle), icon (icon + title + subtitle). */
  variant = input<TestimonialCardVariant>('testimonial');

  imageUrl = input.required<string>();
  quote = input.required<string>();
  authorName = input<string>('');
  authorRole = input<string>('');
  avatarUrl = input<string>();

  /** For variant 'quote': optional subtitle below the quote. */
  subtitle = input<string>('');
  /** For variant 'quote': quote typography size. */
  quoteSize = input<'md' | 'lg'>('md');
  /** For variant 'quote': whether the quote uses italic. */
  quoteItalic = input<boolean>(false);

  /** For variant 'icon': Material icon name. */
  iconName = input<string>('');
  /** For variant 'icon': title text (replaces quote in display). */
  title = input<string>('');
  /** For variant 'icon': whether title is italic. */
  titleItalic = input<boolean>(true);
  /** For variant 'icon': whether to wrap title in quotation marks. */
  titleInQuotes = input<boolean>(false);
}
